import { useMutation, useQueryClient } from '@tanstack/vue-query'
import type { VariableType } from 'shared/src'
import fetchApi from '@/utils/fetchApi'

export interface CreateVariableParams {
  name: string
  type: VariableType
  fallbackValue: string
  description?: string
}

export function useCreateVariableMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (params: CreateVariableParams) => {
      return fetchApi<{ id: string }>(
        {
          endpoint: '/api/variables/create',
          method: 'POST',
          body: params,
        },
        { suppressAlert: true },
      )
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['variables', 'list'] })
      void queryClient.invalidateQueries({ queryKey: ['variables', 'all'] })
    },
  })
}
